import { render, staticRenderFns } from "./ResetPasswordVerify.vue?vue&type=template&id=46037852"
import script from "./ResetPasswordVerify.vue?vue&type=script&lang=js"
export * from "./ResetPasswordVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports